/**
 * Reads a message from common API error JSON bodies.
 * Prefers Strapi `error.message`, then top-level `message` (Stream Hub).
 */
export function readApiErrorMessage(data: unknown): string | undefined {
  if (!data || typeof data !== "object") return undefined

  const payload = data as {
    message?: unknown
    error?: { message?: unknown }
  }

  if (
    payload.error &&
    typeof payload.error === "object" &&
    typeof payload.error.message === "string"
  ) {
    return payload.error.message
  }

  if (typeof payload.message === "string") return payload.message
  if (payload.message != null) return String(payload.message)

  return undefined
}
